import { Route, Routes } from 'react-router-dom';
import SupervisorsList from './components/SupervisorsList';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';

export function SupervisorRoutes() {
    return <Routes>{hasAccessRight(AdminAclEnum.SUPERVISORS) && <Route index element={<SupervisorsList />} />}</Routes>;
}
